export const getCardStyles = checked => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '14px 16px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${checked ? palette.primary.main : palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
});

export const hintStyles = {
  marginLeft: '30px',
  color: ({ palette }) => palette.text.secondary,
};

export const labelStyles = {
  color: ({ palette }) => palette.text.primary,
};
